import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IUmbTypeState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const umbTypeModule: Module<IUmbTypeState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default umbTypeModule
